import React from "react";
import './index.css';

import {ReactComponent as ReactLogo} from './logo.svg'

const Footer = () => {

  return (
    <div className="footer">
        <div className="topBar">
            <ReactLogo className="logo2" onClick={(e) => {e.preventDefault(); window.location.href='https://michigandaily.com/';}}/>
            <ul class="social-icons">
                <li><a href="https://www.facebook.com/michigandaily" class="social-icon"> <i class="fa fa-facebook"></i></a></li>
                <li><a href="https://twitter.com/michigandaily" class="social-icon"> <i class="fa fa-twitter"></i></a></li>
                <li><a href="https://www.instagram.com/michigandaily/" class="social-icon"> <i class="fa fa-instagram"></i></a></li>
                <li><a href="https://www.youtube.com/user/michdailymultimedia" class="social-icon"> <i class="fa fa-youtube"></i></a></li>
                <li><a href="https://leadersandbest.umich.edu/find/#!/give/basket/fund/314932?Amount=20" class="social-icon"> <i class="fa fa-dollar"></i></a></li>
        </ul>
        </div>
    </div>
  );
};

export default Footer;
